/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OAuthBindCodeExchangeReqVo,
  OAuthBindEmailCodeReqVo,
  OAuthBindEmailReqVo,
  OAuthBindMobileCodeReqVo,
  OAuthBindReqVo,
  OAuthCodeExchangeReqVo,
  RedirectView,
  ResponseOAuthAuthorizeResVo,
  ResponseOAuthBindCodeExchangeResVo,
  ResponseString,
  ResponseUserLoginResVo,
} from '../models/index';
import {
    OAuthBindCodeExchangeReqVoFromJSON,
    OAuthBindCodeExchangeReqVoToJSON,
    OAuthBindEmailCodeReqVoFromJSON,
    OAuthBindEmailCodeReqVoToJSON,
    OAuthBindEmailReqVoFromJSON,
    OAuthBindEmailReqVoToJSON,
    OAuthBindMobileCodeReqVoFromJSON,
    OAuthBindMobileCodeReqVoToJSON,
    OAuthBindReqVoFromJSON,
    OAuthBindReqVoToJSON,
    OAuthCodeExchangeReqVoFromJSON,
    OAuthCodeExchangeReqVoToJSON,
    RedirectViewFromJSON,
    RedirectViewToJSON,
    ResponseOAuthAuthorizeResVoFromJSON,
    ResponseOAuthAuthorizeResVoToJSON,
    ResponseOAuthBindCodeExchangeResVoFromJSON,
    ResponseOAuthBindCodeExchangeResVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseUserLoginResVoFromJSON,
    ResponseUserLoginResVoToJSON,
} from '../models/index';

export interface AuthOauthBindCodePostRequest {
    oAuthBindCodeExchangeReqVo?: OAuthBindCodeExchangeReqVo;
}

export interface AuthOauthBindEmailCodePostRequest {
    oAuthBindEmailCodeReqVo?: OAuthBindEmailCodeReqVo;
}

export interface AuthOauthBindEmailPostRequest {
    oAuthBindEmailReqVo?: OAuthBindEmailReqVo;
}

export interface AuthOauthBindMobileCodePostRequest {
    oAuthBindMobileCodeReqVo?: OAuthBindMobileCodeReqVo;
}

export interface AuthOauthBindPostRequest {
    oAuthBindReqVo?: OAuthBindReqVo;
}

export interface AuthOauthLoginCodePostRequest {
    oAuthCodeExchangeReqVo?: OAuthCodeExchangeReqVo;
}

export interface KakaoCallbackGetRequest {
    code?: string;
    state?: string;
    error?: string;
}

/**
 * 
 */
export class OAuthOAuthControllerApi extends runtime.BaseAPI {

    /**
     * 用一次性交接码换取绑定凭证。 OAuth登录·交接码换绑定凭证
     * OAuth登录·交接码换绑定凭证
     */
    async authOauthBindCodePostRaw(requestParameters: AuthOauthBindCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOAuthBindCodeExchangeResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/bind-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthBindCodeExchangeReqVoToJSON(requestParameters['oAuthBindCodeExchangeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOAuthBindCodeExchangeResVoFromJSON(jsonValue));
    }

    /**
     * 用一次性交接码换取绑定凭证。 OAuth登录·交接码换绑定凭证
     * OAuth登录·交接码换绑定凭证
     */
    async authOauthBindCodePost(requestParameters: AuthOauthBindCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOAuthBindCodeExchangeResVo> {
        const response = await this.authOauthBindCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 向待绑定邮箱发送验证码。 OAuth登录·发送绑定邮箱验证码
     * OAuth登录·发送绑定邮箱验证码
     */
    async authOauthBindEmailCodePostRaw(requestParameters: AuthOauthBindEmailCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/bind/email-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthBindEmailCodeReqVoToJSON(requestParameters['oAuthBindEmailCodeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 向待绑定邮箱发送验证码。 OAuth登录·发送绑定邮箱验证码
     * OAuth登录·发送绑定邮箱验证码
     */
    async authOauthBindEmailCodePost(requestParameters: AuthOauthBindEmailCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.authOauthBindEmailCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 邮箱验证后绑定已有账号并登录。 OAuth登录·邮箱绑定已有账号
     * OAuth登录·邮箱绑定已有账号
     */
    async authOauthBindEmailPostRaw(requestParameters: AuthOauthBindEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserLoginResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/bind/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthBindEmailReqVoToJSON(requestParameters['oAuthBindEmailReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserLoginResVoFromJSON(jsonValue));
    }

    /**
     * 邮箱验证后绑定已有账号并登录。 OAuth登录·邮箱绑定已有账号
     * OAuth登录·邮箱绑定已有账号
     */
    async authOauthBindEmailPost(requestParameters: AuthOauthBindEmailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserLoginResVo> {
        const response = await this.authOauthBindEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 向待绑定手机号发送验证码。 OAuth登录·发送绑定验证码
     * OAuth登录·发送绑定验证码
     */
    async authOauthBindMobileCodePostRaw(requestParameters: AuthOauthBindMobileCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/bind/mobile-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthBindMobileCodeReqVoToJSON(requestParameters['oAuthBindMobileCodeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 向待绑定手机号发送验证码。 OAuth登录·发送绑定验证码
     * OAuth登录·发送绑定验证码
     */
    async authOauthBindMobileCodePost(requestParameters: AuthOauthBindMobileCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.authOauthBindMobileCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 短信验证后绑定已有账号并登录。 OAuth登录·绑定已有账号
     * OAuth登录·绑定已有账号
     */
    async authOauthBindPostRaw(requestParameters: AuthOauthBindPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserLoginResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/bind`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthBindReqVoToJSON(requestParameters['oAuthBindReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserLoginResVoFromJSON(jsonValue));
    }

    /**
     * 短信验证后绑定已有账号并登录。 OAuth登录·绑定已有账号
     * OAuth登录·绑定已有账号
     */
    async authOauthBindPost(requestParameters: AuthOauthBindPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserLoginResVo> {
        const response = await this.authOauthBindPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 返回 Kakao 官方授权地址。 OAuth登录·获取Kakao授权地址
     * OAuth登录·获取Kakao授权地址
     */
    async authOauthKakaoAuthorizeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOAuthAuthorizeResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/kakao/authorize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOAuthAuthorizeResVoFromJSON(jsonValue));
    }

    /**
     * 返回 Kakao 官方授权地址。 OAuth登录·获取Kakao授权地址
     * OAuth登录·获取Kakao授权地址
     */
    async authOauthKakaoAuthorizeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOAuthAuthorizeResVo> {
        const response = await this.authOauthKakaoAuthorizeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 用一次性登录码换取系统 Token。 OAuth登录·登录码换Token
     * OAuth登录·登录码换Token
     */
    async authOauthLoginCodePostRaw(requestParameters: AuthOauthLoginCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserLoginResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/oauth/login-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthCodeExchangeReqVoToJSON(requestParameters['oAuthCodeExchangeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserLoginResVoFromJSON(jsonValue));
    }

    /**
     * 用一次性登录码换取系统 Token。 OAuth登录·登录码换Token
     * OAuth登录·登录码换Token
     */
    async authOauthLoginCodePost(requestParameters: AuthOauthLoginCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserLoginResVo> {
        const response = await this.authOauthLoginCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 接收 Kakao 授权回调，路径对齐控制台 Redirect URI。 OAuth登录·Kakao授权回调
     * OAuth登录·Kakao授权回调
     */
    async kakaoCallbackGetRaw(requestParameters: KakaoCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedirectView>> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/kakao/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedirectViewFromJSON(jsonValue));
    }

    /**
     * 接收 Kakao 授权回调，路径对齐控制台 Redirect URI。 OAuth登录·Kakao授权回调
     * OAuth登录·Kakao授权回调
     */
    async kakaoCallbackGet(requestParameters: KakaoCallbackGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedirectView> {
        const response = await this.kakaoCallbackGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
